import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetCategoryListQuery } from "../../Services/CategoryAPI";
import { useGetBrandListQuery } from "../../Services/BrandsAPI";
import { useGetProductByIdQuery, useUpdateProductMutation } from "../../Services/ProductAPI";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { Tabs, Tab } from "react-bootstrap";
import Stockmanagement from "../stock-management/add"
// import AddVariant from "../add-varients/list"

function AddProduct() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [key, setKey] = useState("home"); // Set default tab

    const handleSelect = (k) => {
      setKey(k); // Update the active tab
  
      // Navigate when "addvariant" tab is selected
      if (k === "addvariant") {
        navigate(`/list-varients-by-product/${id}`);
      }
    };

    // State variables
    const [productCode, setProductCode] = useState("");
    const [productName, setProductName] = useState("");
    const [productImage, setProductImage] = useState(null);
    const [productImage1, setProductImage1] = useState(null);
    const [productImage2, setProductImage2] = useState(null);
    const [productImage3, setProductImage3] = useState(null);
    const [productPrice, setProductPrice] = useState("");
    const [sellingPrice, setSellingPrice] = useState("");
    const [additionalInfo, setAdditionalInfo] = useState("");
    const [productBrand, setProductBrand] = useState("");
    const [category, setcategory] = useState("");
    const [description, setDescription] = useState("");
    const [detailedDescription, setDetailedDescription] = useState("");
    const [isFeatured, setIsFeatured] = useState("No");
    const [isNew, setIsNew] = useState(0);
    const [isHot, setIsHot] = useState(0);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    // const [key, setKey] = useState("home");
    // API Hooks
    const { data: parentCategories } = useGetCategoryListQuery();
    const { data: brandList } = useGetBrandListQuery();

    const [updateProduct, { isLoading }] = useUpdateProductMutation();
    const { data: productDetail, isLoading: loadingContent, error, refetch: refetchProductDetail } = useGetProductByIdQuery(id);

    useEffect(() => {
        refetchProductDetail();
    }, [refetchProductDetail])

    useEffect(() => {
        if (productDetail) {
            setProductCode(productDetail?.data?.product_code || "");
            setProductName(productDetail?.data?.product_name || "");
            setProductPrice(productDetail?.data?.product_price || "");
            setSellingPrice(productDetail?.data?.selling_price || "");
            setDescription(productDetail?.data?.description || "");
            setAdditionalInfo(productDetail?.data?.additional_info || "")
            setDetailedDescription(productDetail?.data?.detailed_description || "");
            setIsFeatured(productDetail?.data?.is_featured || "No");
            setIsNew(productDetail?.data?.is_new || 0);
            setIsHot(productDetail?.data?.is_hot || 0);
            setcategory(productDetail?.data?.category_id || "");
            setProductBrand(productDetail?.data?.brand_id || "");
        }

    }, [productDetail])

    const validateImage = (file) => {
        return new Promise((resolve) => {
            if (!file) {
                resolve("Product Image is required");
                return;
            }

            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                if (img.width !== 800 || img.height !== 800) {
                    resolve("Product Image must be exactly 800x800 pixels");
                } else {
                    resolve(null);
                }
            };

            img.onerror = () => {
                resolve("Invalid image file");
            };
        });
    };

    // ✅ Validate Form
    const validateForm = async () => {
        let newErrors = {};
        if (!productCode.trim()) newErrors.productCode = "Product Code is required";
        if (!productName.trim()) newErrors.productName = "Product Name is required";
        if (!category) newErrors.category = "Category is required";

        if (!productPrice.trim() || isNaN(productPrice)) {
            newErrors.productPrice = "Valid Product Price is required";
        }
        else if (parseFloat(productPrice) < parseFloat(sellingPrice)) {
            newErrors.productPrice = "Product Price should be greater than or equal to Selling Price";
        }


        if (!description.trim()) newErrors.description = "Description is required";
        const imageError = await validateImage(productImage);
        if (imageError) {
            newErrors.productImage = imageError;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ✅ Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("product_code", productCode);
        formData.append("product_name", productName);
        if (productImage) {
            formData.append("main_image", productImage);
        }

        formData.append("product_price", productPrice);
        formData.append("brand_id", productBrand);
        formData.append("category_id", category);
        if (sellingPrice) {
            formData.append("selling_price", sellingPrice);
        }
        else {
            formData.append("selling_price", productPrice);
        }

        formData.append("description", description);
        if (productImage1) {
            formData.append("product_image_two", productImage1);
        }
        if (productImage2) {
            formData.append("product_image_three", productImage2);
        }
        if (productImage3) {
            formData.append("product_image_four", productImage3);
        }
        formData.append("additional_info", additionalInfo);
        formData.append("detailed_description", detailedDescription);
        formData.append("is_featured", isFeatured || "No");
        formData.append("is_best_seller", 0);
        formData.append("is_new", isNew || 0);
        formData.append("is_hot", isHot || 0);

        try {
            await updateProduct({ formData, id }).unwrap();
            alert("Product Updated successfully!");

            // Reset form fields
            setProductName("");
            setProductImage(null);
            setProductImage1(null);
            setProductImage2(null);
            setProductImage3(null);
            setProductPrice("");
            setSellingPrice("");
            setcategory("");
            setDescription("");
            setProductCode("");
            setIsFeatured(0);
            setErrors({});
            setApiError(null);
            navigate("/products");
        } catch (error) {
            if(error.status === 405){
                setApiError("Invalid Image");
            }
            else{
                setApiError(error.data?.message || "Something went wrong");
            }
           
        }
    };
    const handleEditorChange = (content) => {
        setDetailedDescription(content); // Correct way to capture content
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;


    const handleEditorChangeDiscription = (content) => {
        setDescription(content);
        if (errors.description) {
            setErrors((prev) => ({ ...prev, description: "" }));
          }
    };
    return (
        <div>
            <h3>Products</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/products"><span>Products</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Edit</span>
                </p>
            </div>
            <div className="content-wrapper">
            <Tabs activeKey={key} onSelect={handleSelect} className="mb-3">
                    <Tab eventKey="home" title="Edit product details">
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                            <div className="row">
                                {/* Product Name */}
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Product Name"
                                            value={productName}
                                            onChange={(e) => {
                                                setProductName(e.target.value);
                                                setErrors((prevErrors) => ({ ...prevErrors, productName: "" }));
                                              }}
                                        />
                                        {errors.productName && <p className="text-danger">{errors.productName}</p>}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Product Code"
                                            value={productCode}
                                            onChange={(e) => {
                                                setProductCode(e.target.value);
                                                setErrors((prevErrors) => ({ ...prevErrors, productCode: "" }));
                                              }}
                                        />
                                        {errors.productCode && <p className="text-danger">{errors.productCode}</p>}
                                    </div>
                                </div>




                                {/* Product Price */}
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Product Price"
                                            value={productPrice}
                                            onChange={(e) => {
                                                setProductPrice(e.target.value);
                                                setErrors((prevErrors) => ({ ...prevErrors, productPrice: "" }));
                                              }}
                                            onKeyPress={(e) => {
                                                if (!/^\d*\.?\d*$/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        {errors.productPrice && <p className="text-danger">{errors.productPrice}</p>}
                                    </div>
                                </div>

                                {/* Selling Price */}
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Selling Price</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Selling Price"
                                            value={sellingPrice}
                                            onChange={(e) => setSellingPrice(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (!/^\d*\.?\d*$/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Parent Category */}
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Select Category</label>
                                        <select
                                            className="form-control"
                                            value={category}
                                            onChange={(e) => {
                                                setcategory(e.target.value);
                                                setErrors((prevErrors) => ({ ...prevErrors, category: "" }));
                                              }}
                                        >
                                            <option value="">Select Category</option>
                                            {parentCategories?.data?.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.category_name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.category && <p className="text-danger">{errors.category}</p>}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Select Brand</label>
                                        <select
                                            className="form-control"
                                            value={productBrand}
                                            onChange={(e) => setProductBrand(e.target.value)}
                                        >
                                            <option value="">Select Brand</option>
                                            {brandList?.brands?.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.productBrand && <p className="text-danger">{errors.productBrand}</p>}
                                    </div>
                                </div>


                                {/* Description */}
                                <div className="col-md-12">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Description</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            value={description}
                                            onEditorChange={handleEditorChangeDiscription}
                                            init={{
                                                height: 300,
                                                menubar: false,
                                                plugins: [
                                                    "advlist",
                                                    "autolink",
                                                    "lists",
                                                    "link",
                                                    "preview",
                                                    "searchreplace",
                                                    "wordcount",
                                                ],
                                                toolbar:
                                                    "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                                content_style:
                                                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                paste_data_images: true,
                                                paste_as_text: false,
                                                paste_enable_default_filters: true,
                                                removed_menuitems: "paste",
                                            }}
                                        />
                                        {errors.description && <p className="text-danger">{errors.description}</p>}
                                    </div>
                                </div>
                                {/* Product Image */}
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => setProductImage(e.target.files[0])}
                                        />
                                        <img src={productDetail?.data?.product_main_image_url_large} width={200} height={200} className="mt-4" alt="img" />
                                    </div>
                                </div>

                            </div>

                            <h5 className="mb-3 mt-4">Add other Images</h5>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Image 2</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => setProductImage1(e.target.files[0])}
                                        />
                                        {productDetail?.data?.product_image_two_url && <img src={productDetail?.data?.product_image_two_url} width={200} height={200} className="mt-4" alt="img" />}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Image 3</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => setProductImage2(e.target.files[0])}
                                        />
                                        {productDetail?.data?.product_image_three_url && <img src={productDetail?.data?.product_image_three_url} width={200} height={200} className="mt-4" alt="img" />}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Product Image 4</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => setProductImage3(e.target.files[0])}
                                        />
                                        {productDetail?.data?.product_image_four_url && <img src={productDetail?.data?.product_image_four_url} width={200} height={200} className="mt-4" alt="img" />}
                                    </div>
                                </div>

                            </div>

                            <h5 className="mb-3 mt-4">Additional Information</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Additional Info</label>
                                        <textarea
                                            rows={4}
                                            className="form-control"
                                            value={additionalInfo}
                                            onChange={(e) => setAdditionalInfo(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="mb-4 text-start">
                                        <label className="form-label">Detailed Description</label>
                                        <Editor
                                            apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                            value={detailedDescription}
                                            onEditorChange={handleEditorChange}
                                            init={{
                                                height: 300,
                                                menubar: false,
                                                plugins: [
                                                    "advlist",
                                                    "autolink",
                                                    "lists",
                                                    "link",
                                                    "preview",
                                                    "searchreplace",
                                                    "wordcount",
                                                ],
                                                toolbar:
                                                    "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                                content_style:
                                                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                                paste_data_images: true,
                                                paste_as_text: false,
                                                paste_enable_default_filters: true,
                                                removed_menuitems: "paste",
                                            }}
                                        />
                                    </div>
                                </div>


                                <div className="col-md-3 col-sm-12 col-lg-3">
                                    <div className="mb-4 text-start d-flex">

                                        <input
                                            type="checkbox"
                                            checked={isFeatured === "Yes"}
                                            name="isFeatured"
                                            onChange={(e) => setIsFeatured(e.target.checked ? "Yes" : "No")}
                                        /><label htmlFor="description" className="form-label w-100">Is Featured <div className="tooltip-container">
                                            <FontAwesomeIcon
                                                icon={faCircleInfo}
                                                className="text-warning mx-2"
                                                style={{ cursor: "pointer" }}
                                            />
                                            <div className="tooltip">If the checkbox is checked, the item will be added as a featured product, and a "Featured" tag will be displayed.</div>
                                        </div></label>
                                    </div>
                                </div>


                                <div className="col-md-3 col-sm-12 col-lg-3">
                                    <div className="mb-4 text-start d-flex">

                                        <input
                                            type="checkbox"
                                            checked={isNew === 1}
                                            name="isNew"
                                            onChange={(e) => setIsNew(e.target.checked ? 1 : 0)}
                                        /><label htmlFor="description" className="form-label w-100">Is New<div className="tooltip-container">
                                            <FontAwesomeIcon
                                                icon={faCircleInfo}
                                                className="text-warning mx-2"
                                                style={{ cursor: "pointer" }}
                                            />
                                            <div className="tooltip">If the checkbox is checked, the item will be added to a new product, and a new tag will be displayed for it.</div>
                                        </div></label>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-12 col-lg-3">
                                    <div className="mb-4 text-start d-flex">

                                        <input
                                            type="checkbox"
                                            checked={isHot === 1}
                                            name="isHot"
                                            onChange={(e) => setIsHot(e.target.checked ? 1 : 0)}
                                        /><label htmlFor="description" className="form-label w-100">Is Hot<div className="tooltip-container">
                                            <FontAwesomeIcon
                                                icon={faCircleInfo}
                                                className="text-warning mx-2"
                                                style={{ cursor: "pointer" }}
                                            />
                                            <div className="tooltip">If the checkbox is checked, hot tag will be displayed for it.</div>
                                        </div></label>
                                    </div>
                                </div>

                            </div>
                            {/* API Error Message */}
                            {apiError && <p className="text-danger text-center">{apiError}</p>}

                            {/* Submit Button */}
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? "Submitting..." : "Submit"}
                            </button>
                        </form>
                    </Tab>
                    <Tab eventKey="profile" title="Add Stock
                    ">
                        <Stockmanagement />
                    </Tab>

                   <Tab eventKey="addvariant" title="Add Variant"   onClick={() => navigate(`/list-varients-by-product/${id}`)}> 
                
                    </Tab>
                </Tabs>
            </div>


        </div>
    );
}

export default AddProduct;
